import { getTranscription } from './services';

const getFileExtension = (mimeType) => {
  if (mimeType.includes('mp4')) return '.mp4';
  if (mimeType.includes('ogg')) return '.ogg';
  return '.webm';
};

const getSupportedMimeType = () => {
  const types = [
    'audio/webm',
    'audio/ogg;codecs=opus',
    'audio/webm;codecs=opus',
    'audio/mp4',
  ];
  return types.find(t => MediaRecorder.isTypeSupported(t)) || '';
};

const uploadAudio = async (blob, setTranscription) => {
  if (blob) {
    try {
      let formData = new FormData();
      const ext = getFileExtension(blob.type);
      formData.append('audio', blob, 'file_' + Date.now().toString() + ext);

      const transcription = await getTranscription(
        formData,
      );

      if(transcription) {
        setTranscription(transcription);
      }
    } catch (error) {
      console.error("Error uploading audio:", error);
    }
  }
};

const startRecording = async (recorderRef, setTranscription) => {
  const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
  const mimeType = getSupportedMimeType();
  const recorder = mimeType
    ? new MediaRecorder(stream, { mimeType })
    : new MediaRecorder(stream);
  const chunks = [];

  recorder.ondataavailable = (event) => {
    chunks.push(event.data);
  };

  recorder.onstop = () => {
    const blob = new Blob(chunks, { type: recorder.mimeType });
    uploadAudio(blob, setTranscription);
    stream.getTracks().forEach((track) => track.stop());
  };

  recorder.start();
  recorderRef.current = recorder;
};

const stopRecording = (recorderRef) => {
  const mediaRecorder = recorderRef.current;
  if (mediaRecorder && mediaRecorder.state !== "inactive") {
    mediaRecorder.stop();
  }
};

export const startTimer = async (timerRef, recorderRef, setTranscription) => {
  await startRecording(recorderRef, setTranscription);
  timerRef.current = setInterval(async () => {
    stopRecording(recorderRef);
    await startRecording(recorderRef, setTranscription);
  }, 7000);
}

export const stopTimer = (timerRef, recorderRef) => {
  clearInterval(timerRef.current);
  stopRecording(recorderRef);
}
